/* OcuLabs homepage v3 (28 Oct 2026): sale countdown, Health Quiz dialog, rails, slideshow, menus, cart count. */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };

  // Sale countdown to the campaign end from the sale calendar.
  document.querySelectorAll('[data-oc3-end]').forEach(function (clock) {
    var end = Date.parse(clock.dataset.oc3End);
    if (!end) { clock.hidden = true; return; }
    var cells = {};
    clock.querySelectorAll('[data-u]').forEach(function (el) { cells[el.dataset.u] = el; });
    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      cells.d.textContent = pad(Math.floor(s / 86400));
      cells.h.textContent = pad(Math.floor(s % 86400 / 3600));
      cells.m.textContent = pad(Math.floor(s % 3600 / 60));
      cells.s.textContent = pad(s % 60);
      if (left <= 0) clearInterval(timer);
    }
    var timer = setInterval(tick, 1000);
    tick();
  });

  var quiz = document.getElementById('oc3-quiz');

  function railOf(el) {
    var box = el.closest('section');
    return box && box.querySelector('[data-oc3-rail]');
  }
  function syncArrows(rail) {
    var box = rail.closest('section');
    if (!box) return;
    var prev = box.querySelector('[data-oc3-scroll="-1"]');
    var next = box.querySelector('[data-oc3-scroll="1"]');
    var max = rail.scrollWidth - rail.clientWidth - 4;
    if (prev) prev.disabled = rail.scrollLeft <= 4;
    if (next) next.disabled = rail.scrollLeft >= max;
  }
  document.querySelectorAll('[data-oc3-rail]').forEach(function (rail) {
    rail.addEventListener('scroll', function () { syncArrows(rail); }, { passive: true });
    window.addEventListener('resize', function () { syncArrows(rail); });
    syncArrows(rail);
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-oc3-quiz-open]');
    if (opener && quiz) {
      event.preventDefault();
      if (typeof quiz.showModal === 'function') quiz.showModal(); else quiz.setAttribute('open', '');
      return;
    }
    if (event.target.closest('[data-oc3-quiz-close]') || event.target === quiz) {
      quiz.close ? quiz.close() : quiz.removeAttribute('open');
      return;
    }
    var arrow = event.target.closest('[data-oc3-scroll]');
    if (arrow) {
      var rail = railOf(arrow);
      if (rail) {
        var card = rail.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth;
        rail.scrollBy({ left: step * Number(arrow.dataset.oc3Scroll), behavior: 'smooth' });
      }
      return;
    }
    // The global cart (oc-cart.js) catches /cart links first; this is the fallback.
    var cart = event.target.closest('[data-oc3-cart]');
    if (cart && window.ocCart && typeof window.ocCart.open === 'function') {
      event.preventDefault();
      window.ocCart.open();
      return;
    }
  });

  // Ingredient slideshow with pause.
  document.querySelectorAll('[data-oc3-slides]').forEach(function (box) {
    var imgs = [].slice.call(box.querySelectorAll('img'));
    var btn = box.querySelector('[data-oc3-pause]');
    var i = 0;
    var playing = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pauseIcon = btn ? btn.innerHTML : '';
    var playIcon = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5v14l12-7z"/></svg>';
    function show(n) { imgs[i].classList.remove('on'); i = n % imgs.length; imgs[i].classList.add('on'); }
    setInterval(function () { if (playing && !document.hidden) show(i + 1); }, 3000);
    if (btn) {
      if (!playing) { btn.innerHTML = playIcon; btn.setAttribute('aria-label', 'Play slideshow'); }
      btn.addEventListener('click', function () {
        playing = !playing;
        btn.innerHTML = playing ? pauseIcon : playIcon;
        btn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
      });
    }
  });

  // Feature slideshow (his ask, 28 Oct 2026: "transition smoothly into different pictures and writing, highlighting a
  // different product"). Each slide stays 6.5 s, then the next product fades in. It waits while the pointer or keyboard
  // focus is on it, while it is off screen and while the tab is hidden; a dot or a swipe changes slide. With reduced
  // motion it does not move by itself.
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-oc3-fslides]').forEach(function (show) {
    var slides = Array.prototype.slice.call(show.querySelectorAll('[data-oc3-fslide]'));
    var dots = Array.prototype.slice.call(show.querySelectorAll('[data-oc3-fdot]'));
    if (slides.length < 2) return;
    var STAY = 6500, at = 0, timer = null, left = STAY, started = 0, hover = false, focus = false, seen = false;
    show.style.setProperty('--oc3-fdur', STAY + 'ms');
    function running() { return !still && seen && !hover && !focus && !document.hidden; }
    function plan() {
      if (timer) { clearTimeout(timer); timer = null; left -= Date.now() - started; }
      var go = running();
      show.classList.toggle('oc3-feature--paused', !go);
      if (go) { started = Date.now(); timer = setTimeout(function () { go_to(at + 1); }, Math.max(0, left)); }
    }
    function go_to(i) {
      if (timer) { clearTimeout(timer); timer = null; }
      at = (i + slides.length) % slides.length;
      left = STAY;
      slides.forEach(function (slide, n) {
        var on = n === at;
        slide.classList.toggle('is-on', on);
        slide.setAttribute('aria-hidden', String(!on));
        if (on) slide.removeAttribute('inert'); else slide.setAttribute('inert', '');
      });
      dots.forEach(function (dot, n) { dot.setAttribute('aria-current', String(n === at)); });
      plan();
    }
    dots.forEach(function (dot, n) { dot.addEventListener('click', function () { go_to(n); }); });
    show.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; plan(); } });
    show.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; plan(); } });
    show.addEventListener('focusin', function () { focus = true; plan(); });
    show.addEventListener('focusout', function (e) { if (!show.contains(e.relatedTarget)) { focus = false; plan(); } });
    var x0 = null, y0 = 0;
    show.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    show.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) go_to(at + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('visibilitychange', plan);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { seen = entries[0].isIntersecting; plan(); }, { threshold: 0.35 }).observe(show);
    } else { seen = true; plan(); }
  });

  // Vision from the store's own pages goes to the cat-layout Vision page (his ask, 28 Oct 2026: "people that are going
  // through the homepage should only see the cat version"). Plain Vision links here get the page's view and the
  // ocu_vision_entry=site marker, which the product page's router (vision-ab-bootstrap) keeps out of the Vision test.
  // Ads and other links straight to the product page still go through the test.
  // 5 Nov 2026, Jonathan: "can you update the home page link so it goes to that": Calming the same way, to its cat-layout
  // page with Vision's gifts (?view=oc-calm-hw-v1) and ocu_calm_entry=site, which calming-ab-bootstrap keeps out of the
  // Calming test.
  var ENTRY = [
    { path: /\/products\/vision-support-bites\/?$/, view: 'oc-vision-hw-v1', param: 'ocu_vision_entry' },
    { path: /\/products\/calming-anxiety-support-chews\/?$/, view: 'oc-calm-hw-v1', param: 'ocu_calm_entry' }
  ];
  var ENTRY_LINKS = 'a[href*="/products/vision-support-bites"], a[href*="/products/calming-anxiety-support-chews"]';
  function entryLink(a) {
    if (!a || !a.getAttribute('href')) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
    var rule = ENTRY.find(function (r) { return r.path.test(u.pathname); });
    if (u.origin !== location.origin || !rule || u.searchParams.has('view')) return;
    u.searchParams.set('view', rule.view);
    u.searchParams.set(rule.param, 'site');
    a.setAttribute('href', u.pathname + u.search + u.hash);
  }
  document.querySelectorAll(ENTRY_LINKS).forEach(entryLink);
  // Links drawn later (the menu panels, search results) are fixed as they are pointed at, clicked or tabbed to.
  ['pointerdown', 'mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest) entryLink(event.target.closest(ENTRY_LINKS));
    }, true);
  });

  // Keep the header count right after the cart drawer changes the cart.
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) document.querySelectorAll('[data-oc3-count]').forEach(function (el) { el.textContent = data.item_count; }); })
      .catch(function () {});
  }
  if (window.MutationObserver) {
    var t;
    var obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(refreshCount, 500); });
    [document.documentElement, document.body].forEach(function (el) { obs.observe(el, { attributes: true, attributeFilter: ['class', 'style'] }); });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });
})();
